import { useTranslation } from 'react-i18next';
import { ExternalLink } from 'src/components/Button/ExternalLink';

export function LearnMorePartsCategoriesButton({ href, onClick }: Readonly<{ href: string; onClick: () => void }>) {
  const { t } = useTranslation('manageProduct');

  return (
    <ExternalLink href={href} onClick={onClick}>
      {t('partsCategories.currentPartsCategories.learnMorePartsCategories')}
    </ExternalLink>
  );
}
